import React, { memo, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import {
  enterFullscreen,
  exitFullscreen,
  isFullscreenActive,
  useFullScreen,
} from '../../../full-screen/full-screen.hook';
import { useTheme } from '../../../themes/theme.provider';
import { useWindow } from '../../../util/window-helper';

const FullScreenComponent = () => {
  const { setFullScreen } = useFullScreen();
  const { themeType } = useTheme();
  const { isMobile } = useWindow();

  const toggleFullScreen = () => {
    if (isFullscreenActive()) {
      exitFullscreen();
      setFullScreen(-1);
    } else {
      enterFullscreen();
      setFullScreen(1);
    }
  };

  useEffect(() => {
    // On mobile, fullscreen is entered from the Start button tap (user gesture).
    // useEffect requests are blocked by the browser after route navigation.
    if (isMobile || isFullscreenActive()) {
      return;
    }
    enterFullscreen();
    setFullScreen(1);
  }, [isMobile, setFullScreen]);

  return (
    <Button
      variant="link"
      className="text-white me-3 p-0"
      onClick={toggleFullScreen}
    >
      <img
        src={`/images/${
          themeType === 'light' ? 'screen-dark.svg' : 'screen.svg'
        } `}
        alt=""
      />
    </Button>
  );
};

export default memo(FullScreenComponent);
